import * as z from "zod";

export const formSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters"),
});

export type FormValues = z.infer<typeof formSchema>;
